import { create, type StoreApi, type UseBoundStore } from 'zustand'

type SearchState = {
  searchTerm: string
  origin: string
  clearSearchTerm: () => void
  clearSearchState: () => void
  setSearchTerm: (searchTerm: string) => void
  setOrigin: (origin: string) => void
}

export const useSearchStore: UseBoundStore<StoreApi<SearchState>> = create<SearchState>((set) => ({
  searchTerm: '',
  origin: '',

  clearSearchTerm: () =>
    set({
      searchTerm: '',
    }),
  clearSearchState: () =>
    set({
      origin: '',
      searchTerm: '',
    }),
  setSearchTerm: (searchTerm: string) => set({ searchTerm }),
  setOrigin: (origin: string) =>
    set({
      origin,
      searchTerm: '',
    }),
}))
